import { GENERAL_URL_API } from "../../../urls";

export const editarBanner = async (bannerData) => {
  try {
    const formData = new FormData();
    
    // Agregar el ID del banner para edición
    formData.append("idBanners", bannerData.idBanners);
    
    // Agregar todos los campos del banner
    formData.append("tipoBanner", bannerData.tipoBanner);
    formData.append("titulo", bannerData.titulo);
    formData.append("tituloIngles", bannerData.tituloIngles || "");
    formData.append("descripcion", bannerData.descripcion || "");
    formData.append("descripcionIngles", bannerData.descripcionIngles || "");
    formData.append("textoBoton", bannerData.textoBoton);
    formData.append("textoBotonIngles", bannerData.textoBotonIngles);
    formData.append("enlaceBoton", bannerData.enlaceBoton);
    formData.append("colorFondo", bannerData.colorFondo || "#ffffff");
    formData.append("colorTitulo", bannerData.colorTitulo || "#000000");
    formData.append("colorDescripcion", bannerData.colorDescripcion || "#666666");
    formData.append("colorBoton", bannerData.colorBoton || "#81c868");
    formData.append("colorTextoBoton", bannerData.colorTextoBoton || "#ffffff");
    formData.append("esGlobal", bannerData.esGlobal ? "1" : "0");
    formData.append("posicionGlobal", bannerData.posicionGlobal || "1");
    formData.append("activo", bannerData.activo ? "1" : "0");
    
    // Agregar la imagen si existe (nueva imagen)
    if (bannerData.imagen) {
      formData.append("imagen", bannerData.imagen);
    }

    const response = await fetch(`${GENERAL_URL_API}/arte/editarBanner.php`, {
      method: "POST",
      credentials: 'include',
      body: formData,
    });

    const data = await response.json();
    
    if (data.status === 1) {
      return {
        status: true,
        info: "Banner editado exitosamente",
        data: data.data
      };
    } else {
      return {
        status: false,
        info: data.info || "Error al editar el banner"
      };
    }
  } catch (error) {
    console.error("Error en editarBanner:", error);
    return {
      status: false,
      info: "Error de conexión al editar el banner"
    };
  }
}; 